// health-check.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {
    private apiUrl: string = environment.apiBaseUrl + '/account/health';
    constructor(private http: HttpClient) {}

    checkHealth(): Observable<any> {
        return this.http.get(this.apiUrl).pipe(
            timeout(5000), // Add timeout to prevent hanging
            catchError(error => {
              console.error('Health check failed:', error);
              // Return a value to complete the observable even on error
              return of({ error: error.message });
            })
          );
    }
}